import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft } from '@phosphor-icons/react';

const Impressum = () => {
  return (
    <div className="min-h-screen bg-dark" data-testid="impressum-page">
      {/* Header */}
      <header className="border-b border-white/10">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-6">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-white/60 hover:text-gold transition-colors text-sm"
            data-testid="impressum-back-link"
          >
            <ArrowLeft size={16} />
            Zurück zur Startseite
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="py-12 md:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h1 className="font-serif text-3xl sm:text-4xl text-white mb-8">Impressum</h1>

            <div className="prose prose-invert max-w-none text-white/70 space-y-8">
              <section>
                <h2 className="font-serif text-xl text-white mb-4">Angaben gemäß § 5 TMG</h2>
                <p>
                  veNta Grundbesitz GmbH<br />
                  Neudörferstraße 5<br />
                  90402 Nürnberg
                </p>
                <p>
                  <strong className="text-white">Handelsregister:</strong> HRB 28575<br />
                  <strong className="text-white">Registergericht:</strong> Amtsgericht Nürnberg
                </p>
                <p>
                  <strong className="text-white">Vertreten durch:</strong><br />
                  Geschäftsführung: Herr Alexander Neises, Diplom-Kaufmann (FH)
                </p>
              </section>

              <section>
                <h2 className="font-serif text-xl text-white mb-4">Kontakt</h2>
                <p>
                  <strong className="text-white">Telefon Nürnberg:</strong> 0911 94 98 0 99<br />
                  <strong className="text-white">Telefon Haan:</strong> 02129/375877-5<br />
                  <strong className="text-white">E-Mail:</strong>{' '}
                  <a href="mailto:info@venta-immobilien.de" className="text-gold hover:underline">
                    info@venta-immobilien.de
                  </a>
                </p>
              </section>

              <section>
                <h2 className="font-serif text-xl text-white mb-4">Aufsichtsbehörde</h2>
                <p>
                  <strong className="text-white">Aufsichtsbehörde:</strong> IHK für München und Oberbayern, Max-Joseph-Straße 2, 80333 München<br />
                  <strong className="text-white">Gewerbeerlaubnis:</strong> gem. §34c GewO erteilt durch das Ordnungsamt der Stadt Nürnberg
                </p>
              </section>

              <section>
                <h2 className="font-serif text-xl text-white mb-4">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
                <p>
                  Herr Alexander Neises, Diplom-Kaufmann (FH)<br />
                  Neudörferstraße 5<br />
                  90402 Nürnberg
                </p>
              </section>

              <section>
                <h2 className="font-serif text-xl text-white mb-4">Streitschlichtung</h2>
                <p>
                  Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
                  <a 
                    href="https://ec.europa.eu/consumers/odr" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-gold hover:underline"
                  >
                    https://ec.europa.eu/consumers/odr
                  </a>
                </p>
                <p>
                  Unsere E-Mail-Adresse finden Sie oben im Impressum. Wir sind nicht bereit oder verpflichtet, 
                  an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
                </p>
              </section>

              <section>
                <h2 className="font-serif text-xl text-white mb-4">Haftung für Inhalte</h2>
                <p>
                  Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
                  nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als 
                  Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde 
                  Informationen zu überwachen oder nach Umständen zu forschen, die auf eine 
                  rechtswidrige Tätigkeit hinweisen.
                </p>
                <p>
                  Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach 
                  den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung 
                  ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung 
                  möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir 
                  diese Inhalte umgehend entfernen.
                </p>
              </section>

              <section>
                <h2 className="font-serif text-xl text-white mb-4">Haftung für Links</h2>
                <p>
                  Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir 
                  keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine 
                  Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige 
                  Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden 
                  zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige 
                  Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
                </p>
              </section>

              <section>
                <h2 className="font-serif text-xl text-white mb-4">Urheberrecht</h2>
                <p>
                  Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten 
                  unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, 
                  Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes 
                  bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. 
                  Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen 
                  Gebrauch gestattet.
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-white/10 py-6">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-white/40 text-xs">
              © {new Date().getFullYear()} veNta Grundbesitz GmbH
            </p>
            <div className="flex gap-6">
              <Link to="/datenschutz" className="text-white/40 hover:text-gold text-xs transition-colors">
                Datenschutz
              </Link>
              <Link to="/" className="text-white/40 hover:text-gold text-xs transition-colors">
                Startseite
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Impressum;
